@import '../../../theme.scss';

verdocs-dialog {
  box-sizing: border-box;
  font-family: $primary-font;

  div {
    box-sizing: border-box;
  }

  .background-overlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 10000;
    position: absolute;
    align-items: center;
    background: var(--verdocs-dialog-backdrop-color, rgba(0, 0, 0, 0.5));
    backdrop-filter: var(--verdocs-dialog-backdrop-filter, none);
    -webkit-backdrop-filter: var(--verdocs-dialog-backdrop-filter, none);
    justify-content: center;
  }

  .dialog {
    width: 520px;
    display: flex;
    max-width: 95%;
    overflow: hidden;
    background: #ffffff;
    flex-direction: column;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    border-radius: var(--verdocs-dialog-radius, 8px);
    position: relative; // For absolute positioning of close button

    .close-button {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #9ca3af;
      transition: color 0.2s;
      z-index: 10;

      &:hover {
        color: #4b5563;
      }
    }
  }

  .heading {
    display: flex;
    padding: 16px 24px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e5e7eb;

    .icon {
      display: none; // Hiding old icon structure based on new design which has strict title + close
    }

    .title {
      font-size: 1.5rem; // 24px
      font-weight: var(--verdocs-dialog-title-weight, 500);
      color: var(--verdocs-dialog-title-color, #242424);
      line-height: 2rem; // 32px
      font-family: $verdocs-primary-font;
    }
  }

  .content {
    padding: 24px;
    font-size: 0.875rem; // 14px
    line-height: 1.25rem; // 20px
    color: var(--verdocs-dialog-content-color, #424242);

    a {
      color: var(--verdocs-link-color, #4c56cb);
      border-bottom: var(--verdocs-link-border, 1px dotted #4c56cb);
      text-decoration: none;
    }

    p {
      margin: 0 0 16px 0;
    }
  }

  .footer {
    padding: 0 24px 24px 24px;
  }
}